import {
    Button,
    Modal,
    ModalCloseButton,
    ModalContent,
    ModalOverlay,
    Table,
    TableContainer,
    ModalBody,
    Tbody,
    Text,
    Th,
    Thead,
    Tr,
    VStack,
    useDisclosure,
    Input,
    HStack,
    useToast,
    Spinner,
    Select as ChakraSelect,
    Td,
    Textarea,
    useColorModeValue,
    Box,
    Heading
} from "@chakra-ui/react";
import React, { useContext, useState, useEffect, useRef } from "react";
import { AppContext } from "../../../context/AppContext";
import Select from "react-select";
import {
    AddService,
    DeleteServices,
    EditAPIKey,
    EditService,
    GetAdminAllServices,
    GetAdminSingleService,
    GetAllServices,
    GetAPIKey,
} from "../../../utils/api";
import Empty from "../../../components/Empty";
import ServicesCard from "../components/ServicesCard";

const Services = () => {
    const addServiceNameRef = useRef();
    const addServiceCodeRef = useRef();
    const addServicePriceRef = useRef();
    const addServerRef = useRef();
    const { AdminToken } = useContext(AppContext);
    const [searched, setSearched] = useState({});
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [deleteModal, setDeleteModal] = React.useState(false);
    const [editModal, setEditModal] = React.useState(false);
    const [pageNo, setPageNo] = useState(1);
    const [limitNo, setLimitNo] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const toast = useToast();
    const [serviceId, setServiceId] = useState("");
    const [modalStat, setModalStat] = useState("");
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [apiModal, setAPIModal] = useState(false);
    const [searchData, setSearchData] = useState([]);
    const [singleService, setSingleService] = useState({});
    const [apiKeys, setApiKeys] = useState({});

    // Theme Colors
    // Theme Colors
    const bg = "gray.900";
    const textColor = "white";
    const subTextColor = "gray.400";
    const borderColor = "gray.700";
    const headerBg = "gray.800";
    const themeColor = "#319795";
    const modalBg = "gray.800";
    const inputBg = "gray.700";

    // Select Styles Variables
    // Select Styles Variables
    const selectBg = "#2D3748";
    const selectBorder = "#4A5568";
    const selectBorderHover = "#718096";
    const optionBgFocused = "var(--chakra-colors-teal-900)";
    const optionColor = "white";
    const selectPlaceholderColor = "var(--chakra-colors-gray-400)";

    const handleAddService = (event) => {
        event.preventDefault();
        let serviceData = {};
        serviceData.serviceName = addServiceNameRef.current.value;
        serviceData.serviceCode = addServiceCodeRef.current.value;
        serviceData.price = addServicePriceRef.current.value || 10;
        serviceData.server = addServerRef.current.value || 'server1';
        if (!serviceData.serviceName || !serviceData.serviceCode) {
            toast({
                title: `Please Fill All Input Boxes`,
                status: "warning",
                isClosable: true,
                duration: 3000,
            });
        } else {
            AddService(serviceData, AdminToken)
                .then((res) => {
                    toast({
                        title: `Service Added Successfully`,
                        status: "success",
                        isClosable: true,
                        duration: 3000,
                    });
                    setData([res.data.service, ...data]);
                    onClose();
                })
                .catch((err) => {
                    toast({
                        title: err.response?.data?.message
                            ? err.response?.data.message
                            : err.message,
                        status: "error",
                        isClosable: true,
                        duration: 3000,
                    });
                });
        }
    };
    const handleEditService = (event) => {
        event.preventDefault();
        let Data = {
            serviceCode: addServiceCodeRef.current.value,
            serviceName: addServiceNameRef.current.value,
            price: addServicePriceRef.current.value
        }
        EditService(serviceId, Data, AdminToken).then((res) => {
            toast({
                title: 'service updated successfully!!!',
                isClosable: true,
                status: 'success'
            })
            CloseBlockModal();
            let currentData = data;
            if (searched?.serviceName) setSearched(Data);
            currentData = currentData.map((el) => {
                if (el._id == serviceId) {
                    el = { ...el, ...Data }
                }
                return el;
            });
            if (currentData.length === 0) {
                setPageNo((pre) => { if (pageNo !== 1) { return pre - 1 } return pre });
            }
            setData([...currentData]);
        }).catch((err) => {
            console.log(err);
            toast({
                title: err.response?.data?.message
                    ? err.response?.data.message
                    : err.message,
                isClosable: true,
                status: 'error'
            })
        })
    }
    const handleDelete = () => {
        DeleteServices(serviceId, AdminToken)
            .then((res) => {
                toast({
                    title: 'service deleted successfully!!!',
                    isClosable: true,
                    status: 'warning'
                })
                let currentData = data;
                currentData = currentData.filter((el) => el._id !== serviceId);
                if (currentData.length === 0) {
                    setPageNo((pre) => { if (pageNo !== 1) { return pre - 1 } return pre });
                }
                setData([...currentData]);
                let current2 = searchData;
                // console.log(current2.length, 'debbugging');
                current2 = current2.filter((el) => el.value != serviceId);
                // console.log(current2.length, 'debbugging');
                setSearchData([...current2]);
                setSearched({});
                CloseBlockModal();
            })
            .catch((err) => {
                toast({
                    title: err.response?.data?.message
                        ? err.response?.data.message
                        : err.message,
                    isClosable: true,
                    status: 'error'
                })
            });
    };
    const OpenBlockModal = (serviceId, stat, el) => {
        setServiceId(serviceId);
        if (stat == "delete") {
            setModalStat("delete");
            setDeleteModal(true);
        } else if (stat == "edit") {
            setSingleService(el);
            setModalStat("edit");
            setEditModal(true);
        }
    };
    const CloseBlockModal = () => {
        if (modalStat == "edit") {
            setEditModal(false);
        } else if (modalStat == "delete") {
            setDeleteModal(false);
        }
    };
    useEffect(() => {
        setLoading(false);
        GetAdminAllServices(AdminToken).then((res) => {
            setSearchData(res.data.services);
        }).catch((err) => {
            console.log(err, 'error saying');
        })
        GetAllServices(AdminToken, pageNo, limitNo)
            .then((res) => {
                setLoading(true);
                setData(res.data.services);
                setTotalPages(res.data.total_pages);
            })
            .catch((err) => {
                setLoading(true);
                console.log(err, "error message");
            });
    }, [limitNo, pageNo]);

    useEffect(() => {
        GetAPIKey(AdminToken).then((res) => {
            setApiKeys(res.data.data);
        }).catch((err) => {
            console.log(err, 'error');
        })
    }, []);
    const handleSubmit = (event) => {
        event.preventDefault();
    };
    const handleChange = (event) => {
        if (event.value != '') {
            GetAdminSingleService(AdminToken, event.value).then((res) => {
                setSearched(res.data.service);
            }).catch((err) => {
                console.log(err, 'error saying');
            })
        }
    };
    const handleAPIUpdate = () => {
        EditAPIKey(AdminToken, apiKeys)
            .then((res) => {
                toast({
                    title: "API Keys Updated Successfully",
                    status: "success",
                    isClosable: true,
                });
                setAPIModal(false);
            })
            .catch((err) => {
                toast({
                    status: "error",
                    title: err.response?.data?.message
                        ? err.response?.data.message
                        : err.message,
                    isClosable: true,
                });
            });
    };

    const customSelectStyles = {
        control: (provided, state) => ({
            ...provided,
            backgroundColor: selectBg,
            borderColor: state.isFocused ? themeColor : selectBorder,
            boxShadow: state.isFocused ? `0 0 0 1px ${themeColor}` : "none",
            "&:hover": {
                borderColor: state.isFocused ? themeColor : selectBorderHover,
            },
        }),
        menu: (provided) => ({
            ...provided,
            backgroundColor: selectBg,
            zIndex: 10,
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected
                ? themeColor
                : state.isFocused
                    ? optionBgFocused
                    : "transparent",
            color: state.isSelected ? "white" : optionColor,
            "&:active": {
                backgroundColor: themeColor,
            },
        }),
        singleValue: (provided) => ({
            ...provided,
            color: optionColor,
        }),
        input: (provided) => ({
            ...provided,
            color: optionColor,
        }),
        placeholder: (provided) => ({
            ...provided,
            color: selectPlaceholderColor,
        }),
    };

    return (
        <VStack
            gap={"1rem"}
            bg={bg}
            align={"end"}
            justify={"start"}
            height={"100%"}
            w={"100%"}
            p={{ base: "1rem", md: "1.5rem" }}
        >
            <HStack wrap="wrap">
                <Button
                    _hover={{
                        bg: "teal.600",
                    }}
                    onClick={() => setAPIModal(true)}
                    color={"white"}
                    bg={themeColor}
                    size="sm"
                >
                    Edit API Key
                </Button>
                <Button
                    _hover={{
                        bg: "teal.600",
                    }}
                    onClick={onOpen}
                    color={"white"}
                    bg={themeColor}
                    size="sm"
                >
                    Add Services
                </Button>

            </HStack>
            <TableContainer
                boxShadow="sm"
                w={"100%"}
                borderRadius="lg"
                borderWidth="1px"
                borderColor={borderColor}
                bg={bg}
            >
                <Table
                    variant="simple"
                    size={["md", "lg", "lg"]}
                    overflowX={"auto"}
                >
                    <Thead bg={headerBg}>
                        <Tr>
                            <Th color={subTextColor}>OTPMARKET</Th>
                            <Th color={subTextColor}>Phantom</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        <Tr>
                            <Td
                                pt={"0.7rem !important"}
                                pb={"0.7rem !important"}
                                borderBottomWidth="1px"
                                borderColor={borderColor}
                            >
                                <Textarea size={'sm'} w={'80%'} value={apiKeys?.otpmarket} disabled={true} h={'1rem'} bg={inputBg} borderColor={borderColor} />
                            </Td>

                            <Td
                                pt={"0.7rem !important"}
                                pb={"0.7rem !important"}
                                borderBottomWidth="1px"
                                borderColor={borderColor}
                            >
                                <Textarea disabled={true} value={apiKeys.phantom} size={'sm'} w={'80%'} bg={inputBg} borderColor={borderColor} />
                            </Td>
                        </Tr>
                    </Tbody>
                </Table>
            </TableContainer>
            <VStack align={'self-end'} w={'100%'}>
                <HStack w={'100%'} justify={'start'}>
                    <VStack align={'start'} w={{ base: '100%', md: '31%' }}>
                        <Text fontWeight={700} pl={'0.14rem'} color={textColor}>
                            Search Services
                        </Text>
                        <Box w="100%">
                            <Select
                                onChange={handleChange}
                                options={searchData}
                                placeholder="Search Service"
                                styles={customSelectStyles}
                            />
                        </Box>
                    </VStack>
                </HStack>
                {
                    searched._id && <TableContainer
                        boxShadow="sm"
                        w={"100%"}
                        borderRadius="lg"
                        borderWidth="1px"
                        borderColor={borderColor}
                        bg={bg}
                    >
                        <Table
                            variant="simple"
                            size={["md", "lg", "lg"]}
                            overflowX={"auto"}
                        >
                            <Thead
                                bg={headerBg}
                            >
                                <Tr>
                                    <Th color={subTextColor}>Service Name</Th>
                                    <Th color={subTextColor}>Service Code</Th>
                                    <Th color={subTextColor}>Server</Th>
                                    <Th color={subTextColor}>Price</Th>
                                    <Th color={subTextColor}>Edit</Th>
                                    <Th color={subTextColor}>Delete</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                <ServicesCard
                                    OpenBlockModal={OpenBlockModal}
                                    CloseBlockModal={CloseBlockModal}
                                    id={searched._id}
                                    serviceName={searched.serviceName}
                                    serviceCode={searched.serviceCode}
                                    price={searched.price}
                                    themeColor={themeColor}
                                    borderColor={borderColor}
                                    textColor={textColor}
                                    subTextColor={subTextColor}
                                    server={searched.server}
                                />
                            </Tbody>
                        </Table>
                    </TableContainer>
                }
            </VStack>
            {!loading && (
                <VStack justify={"center"} w={"100%"} minH={"50vh"}>
                    <Spinner
                        thickness="5px"
                        speed="0.55s"
                        emptyColor="gray.200"
                        color={themeColor}
                        size="xl"
                    />
                </VStack>
            )}
            <HStack gap={"1rem"} align={"center"} wrap="wrap" justify="center" w="full">
                <ChakraSelect
                    onChange={(e) => {
                        setLimitNo(Number(e.target.value));
                        setPageNo(1);
                    }}
                    borderColor={borderColor}
                    color={textColor}
                    _focus={{ borderColor: themeColor }}
                    w="80px"
                >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={40}>40</option>
                    <option value={60}>60</option>
                    <option value={80}>80</option>
                    <option value={100}>100</option>
                </ChakraSelect>
                <Button
                    onClick={() => {
                        setPageNo(1);
                    }}
                    padding={"0.5rem 1rem"}
                    width={"fit-content"}
                    color={themeColor}
                    borderColor={themeColor}
                    variant="outline"
                    _hover={{ bg: "teal.50" }}
                >
                    First
                </Button>
                <Button
                    onClick={() => {
                        setPageNo((pre) => {
                            if (pre > 1) {
                                return pre - 1;
                            } else {
                                return pre;
                            }
                        });
                    }}
                    color={themeColor}
                    borderColor={themeColor}
                    variant="outline"
                    _hover={{ bg: "teal.50" }}
                >
                    {"<<"}
                </Button>
                <Text
                    padding={"0.5rem 1rem"}
                    border={"1px solid"}
                    borderColor={borderColor}
                    borderRadius={"5px"}
                    color={textColor}
                >
                    {pageNo}
                </Text>
                <Text color={subTextColor}>/</Text>
                <Text
                    padding={"0.5rem 1rem"}
                    border={"1px solid"}
                    borderColor={borderColor}
                    borderRadius={"5px"}
                    color={textColor}
                >
                    {totalPages}
                </Text>
                <Button
                    onClick={() => {
                        setPageNo((pre) => {
                            if (pre < totalPages) {
                                return pre + 1;
                            } else {
                                return pre;
                            }
                        });
                    }}
                    color={themeColor}
                    borderColor={themeColor}
                    variant="outline"
                    _hover={{ bg: "teal.50" }}
                >
                    {">>"}
                </Button>
                <Button
                    onClick={() => {
                        setPageNo(totalPages);
                    }}
                    padding={"0.5rem 1rem"}
                    width={"fit-content"}
                    color={themeColor}
                    borderColor={themeColor}
                    variant="outline"
                    _hover={{ bg: "teal.50" }}
                >
                    Last
                </Button>
            </HStack>
            {data.length && loading ? (
                <TableContainer
                    boxShadow="sm"
                    w={"100%"}
                    borderRadius="lg"
                    borderWidth="1px"
                    borderColor={borderColor}
                    bg={bg}
                >
                    <Table
                        variant="simple"
                        size={["md", "lg", "lg"]}
                        overflowX={"auto"}
                    >
                        <Thead
                            bg={headerBg}
                        >
                            <Tr>
                                <Th color={subTextColor}>Service Name</Th>
                                <Th color={subTextColor}>Service Code</Th>
                                <Th color={subTextColor}>Server</Th>
                                <Th color={subTextColor}>Price</Th>
                                <Th color={subTextColor}>Edit</Th>
                                <Th color={subTextColor}>Delete</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {data?.map((el) => {
                                return (
                                    <ServicesCard
                                        OpenBlockModal={OpenBlockModal}
                                        CloseBlockModal={CloseBlockModal}
                                        key={el._id}
                                        id={el._id}
                                        // isBlock={el.isBlock}
                                        serviceName={el.serviceName}
                                        serviceCode={el.serviceCode}
                                        price={el.price}
                                        themeColor={themeColor}
                                        server={el.server}
                                        borderColor={borderColor}
                                        textColor={textColor}
                                        subTextColor={subTextColor}
                                    />
                                );
                            })}
                        </Tbody>
                    </Table>
                </TableContainer>
            ) : (
                <></>
            )}
            {!data.length && loading ? (
                <Empty title={"No service found!!!"} />
            ) : (
                <></>
            )}
            {/* Edit User Model */}
            <Modal isOpen={editModal} onClose={CloseBlockModal}>
                <ModalOverlay />
                <ModalContent bg={modalBg}>
                    <ModalCloseButton color={textColor} />
                    <ModalBody
                        display={"flex"}
                        justifyContent={"center"}
                        minH={"30vh"}
                        gap={"1rem"}
                        alignItems={"center"}
                        pb={6}
                        pt={5}
                    >
                        <form
                            style={{ width: "76.5%" }}
                            onSubmit={handleSubmit}
                        >
                            <VStack p={"1.5rem 0.8rem"} align="flex-start">
                                <Input
                                    placeholder="Service Name"
                                    defaultValue={singleService.serviceName}
                                    ref={addServiceNameRef}
                                    bg={inputBg}
                                    borderColor={borderColor}
                                    color={textColor}
                                />
                                <Input
                                    placeholder="Service Code"
                                    defaultValue={singleService.serviceCode}
                                    ref={addServiceCodeRef}
                                    bg={inputBg}
                                    borderColor={borderColor}
                                    color={textColor}
                                />
                                <Input
                                    type={"number"}
                                    placeholder="price"
                                    defaultValue={singleService.price}
                                    ref={addServicePriceRef}
                                    bg={inputBg}
                                    borderColor={borderColor}
                                    color={textColor}
                                />
                                <Button
                                    _hover={{
                                        bg: "teal.600",
                                    }}
                                    type="submit"
                                    mt={"2rem !important"}
                                    bg={themeColor}
                                    color={"white"}
                                    width="full"
                                    outline={"none"}
                                    onClick={handleEditService}
                                >
                                    Edit Service
                                </Button>
                            </VStack>
                        </form>
                    </ModalBody>
                </ModalContent>
            </Modal>
            {/* Delete User Modal  */}
            <Modal isOpen={deleteModal} onClose={CloseBlockModal}>
                <ModalOverlay />
                <ModalContent bg={modalBg}>
                    <ModalCloseButton color={textColor} />
                    <ModalBody
                        display={"flex"}
                        justifyContent={"center"}
                        minH={"30vh"}
                        flexDirection={"column"}
                        gap={"1rem"}
                        alignItems={"center"}
                        pb={6}
                    >
                        <Text fontSize={"1.4rem"} fontWeight={"600"} color={textColor}>
                            Are you sure to Delete This service!!!
                        </Text>
                        <HStack>
                            <Button
                                onClick={() => {
                                    handleDelete();
                                }}
                                _hover={{
                                    bg: "red.600",
                                }}
                                color={"white"}
                                bg={"red.500"}
                            >
                                Confirm
                            </Button>
                            <Button
                                color={textColor}
                                bg={"transparent"}
                                border="1px solid"
                                borderColor={borderColor}
                                _hover={{
                                    bg: "gray.100",
                                }}
                                onClick={CloseBlockModal}
                            >
                                Cancel
                            </Button>
                        </HStack>
                    </ModalBody>
                </ModalContent>
            </Modal>
            {/* Add User Modal  */}
            <Modal isOpen={isOpen} onClose={onClose}>
                <ModalOverlay />
                <ModalContent bg={modalBg}>
                    <ModalCloseButton color={textColor} />
                    <ModalBody
                        display={"flex"}
                        justifyContent={"center"}
                        minH={"30vh"}
                        gap={"1rem"}
                        alignItems={"center"}
                        pb={6}
                        pt={5}
                    >
                        <form
                            style={{ width: "76.5%" }}
                            onSubmit={handleSubmit}
                        >
                            <VStack p={"1.5rem 0.8rem"} align="flex-start">
                                <Input
                                    placeholder="Service Name"
                                    ref={addServiceNameRef}
                                    bg={inputBg}
                                    borderColor={borderColor}
                                    color={textColor}
                                />
                                <Input
                                    placeholder="Service Code"
                                    ref={addServiceCodeRef}
                                    bg={inputBg}
                                    borderColor={borderColor}
                                    color={textColor}
                                />
                                <Input
                                    type={"number"}
                                    placeholder="price"
                                    ref={addServicePriceRef}
                                    bg={inputBg}
                                    borderColor={borderColor}
                                    color={textColor}
                                />
                                <ChakraSelect ref={addServerRef} bg={inputBg} borderColor={borderColor} color={textColor}>
                                    <option value="server1">Server1</option>
                                    <option value="server2">Server2</option>
                                    <option value="server3">Server3</option>
                                    <option value="server4">Server4</option>
                                    <option value="server5">Server5</option>
                                </ChakraSelect>
                                <Button
                                    _hover={{
                                        bg: "teal.600",
                                    }}
                                    type="submit"
                                    mt={"2rem !important"}
                                    bg={themeColor}
                                    color={"white"}
                                    width="full"
                                    outline={"none"}
                                    onClick={handleAddService}
                                >
                                    Add new service
                                </Button>
                            </VStack>
                        </form>
                    </ModalBody>
                </ModalContent>
            </Modal>
            {/* Edit API Model */}
            <Modal isOpen={apiModal} onClose={() => setAPIModal(false)}>
                <ModalOverlay />
                <ModalContent bg={modalBg}>
                    <ModalCloseButton color={textColor} />
                    <ModalBody
                        display={"flex"}
                        justifyContent={"center"}
                        minH={"30vh"}
                        gap={"1rem"}
                        alignItems={"center"}
                        pb={6}
                        pt={5}
                    >
                        <form style={{ width: "76.5%" }} onSubmit={handleSubmit}>
                            <VStack p={"1.5rem 0.8rem"} align="center" >
                                <Text w={'100%'} color={textColor}>OTPMARKET</Text>
                                <Textarea
                                    placeholder="Enter otpmarket api key"
                                    value={apiKeys.otpmarket}
                                    onChange={(e) => {
                                        setApiKeys({ ...apiKeys, otpmarket: e.target.value?.trim() });
                                    }}
                                    bg={inputBg}
                                    borderColor={borderColor}
                                    color={textColor}
                                />
                                <Text w={'100%'} color={textColor}>PHANTOM</Text>
                                <Textarea
                                    placeholder="Enter phantom api key"
                                    value={apiKeys.phantom}
                                    onChange={(e) => {
                                        setApiKeys({ ...apiKeys, phantom: e.target.value?.trim() });
                                    }}
                                    bg={inputBg}
                                    borderColor={borderColor}
                                    color={textColor}
                                />
                                <Button
                                    _hover={{
                                        bg: "teal.600",
                                    }}
                                    type="submit"
                                    mt={"2rem !important"}
                                    bg={themeColor}
                                    color={"white"}
                                    width="full"
                                    outline={"none"}
                                    onClick={handleAPIUpdate}
                                >
                                    Edit API Keys
                                </Button>
                            </VStack>
                        </form>
                    </ModalBody>
                </ModalContent>
            </Modal>
        </VStack>
    );
};

export default Services;
